import { ReactComponent as Plus } from '../../assets/nodeIcons/plus.svg';
import { ReactComponent as Minus } from '../../assets/nodeIcons/minus.svg';

export const ExpandCollapseBtn = ({ iconSign = 'plus', onClick }) => (
  <div onClick={onClick} className="node__expand-collapse-btn">
    {iconSign === 'plus' ? <Plus /> : <Minus />}
  </div>
);
